import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {Header, Titulo} from '../elementos/Header'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioPublicacion from './FormularioPublicacion'
import favicon from '../imagenes/logoutm.png'

const RegistroObjeto = () => {
    return (
        <>
            <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                        <title>Registro de Publicación</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <Header>
                    <Titulo>Registro de Publicación</Titulo>
                    <BtnRegresar ruta="/publicaciones"/>
            </Header>

            <FormularioPublicacion />
        </>
    );
}
 
export default RegistroObjeto;